if (!customElements.get('nc-hero-slider')) {
  class NcHeroSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.timer = null;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.nc-hero-slide'));
      this.dotsContainer = this.querySelector('.nc-hero-dots');
      this.prevBtn = this.querySelector('.nc-hero-arrow--prev');
      this.nextBtn = this.querySelector('.nc-hero-arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.speed, 10) || 6000;

      if (this.slides.length <= 1) {
        if (this.prevBtn) this.prevBtn.style.display = 'none';
        if (this.nextBtn) this.nextBtn.style.display = 'none';
        if (this.dotsContainer) this.dotsContainer.style.display = 'none';
        return;
      }

      this.createDots();
      this.initEvents();
      this.startAutoplay();
    }

    createDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      this.slides.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `nc-hero-dot ${idx === 0 ? 'is-active' : ''}`;
        dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
        dot.addEventListener('click', () => {
          this.goToSlide(idx);
          this.restartAutoplay();
        });
        this.dotsContainer.appendChild(dot);
      });
      this.dots = Array.from(this.dotsContainer.querySelectorAll('.nc-hero-dot'));
    }

    initEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.prevSlide();
          this.restartAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.nextSlide();
          this.restartAutoplay();
        });
      }

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    goToSlide(index) {
      if (index < 0) index = this.slides.length - 1;
      if (index >= this.slides.length) index = 0;

      this.slides.forEach((slide, idx) => {
        slide.classList.toggle('is-active', idx === index);
      });

      if (this.dots) {
        this.dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === index);
        });
      }

      this.currentIndex = index;
    }

    nextSlide() {
      this.goToSlide(this.currentIndex + 1);
    }

    prevSlide() {
      this.goToSlide(this.currentIndex - 1);
    }

    startAutoplay() {
      if (!this.autoplay || this.slides.length <= 1) return;
      this.stopAutoplay();
      this.timer = setInterval(() => this.nextSlide(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }
  }

  customElements.define('nc-hero-slider', NcHeroSlider);
}
